import { render, staticRenderFns } from "./Service.vue?vue&type=template&id=4e428c6f&scoped=true&"
var script = {}
import style0 from "./Service.vue?vue&type=style&index=0&id=4e428c6f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e428c6f",
  null
  
)

export default component.exports